import {Component, Input, OnChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ResultData} from '../search-result-list/search-result-list.component.types';
import {FormControl} from '@angular/forms';


@Component({
  selector: 'app-form-chip-list',
  imports: [CommonModule],
  templateUrl: './form-chip-list.component.html',
  styleUrl: './form-chip-list.component.scss'
})
export class FormChipListComponent implements OnChanges{
  @Input() chips: ResultData[] = [];
  @Input() control!:FormControl;

  ngOnChanges() {
    this.control.setValue(this.chips);
  }

  onRemoveChip(chip: ResultData) {
    chip.isSelected = false;
  }
}
